import { useSyncExternalStore } from 'react';
import {
  getViewportSafeAreaLayoutEpoch,
  subscribeViewportSafeAreaLayoutEpoch,
} from '../../utils/ui/viewportSafeAreaLayoutEpoch';

/**
 * Integer that increments after orientation / bfcache restores that often
 * require remounting fixed or sticky chrome so env(safe-area-inset-*) recomputes.
 */
export default function useViewportSafeAreaLayoutEpoch() {
  return useSyncExternalStore(
    subscribeViewportSafeAreaLayoutEpoch,
    getViewportSafeAreaLayoutEpoch,
    getViewportSafeAreaLayoutEpoch,
  );
}
